var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6317_82944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1 22.5C10.7 22.5 9.3875 22.2333 8.1625 21.7C6.9375 21.1667 5.87083 20.4458 4.9625 19.5375C4.05417 18.6292 3.33333 17.5625 2.8 16.3375C2.26667 15.1125 2 13.8 2 12.4C2 9.96667 2.775 7.82083 4.325 5.9625C5.875 4.10417 7.85 2.95 10.25 2.5C9.95 4.15 10.0417 5.7625 10.525 7.3375C11.0083 8.9125 11.8417 10.2917 13.025 11.475C14.2083 12.6583 15.5875 13.4917 17.1625 13.975C18.7375 14.4583 20.35 14.55 22 14.25C21.5667 16.65 20.4167 18.625 18.55 20.175C16.6833 21.725 14.5333 22.5 12.1 22.5Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6317_82944"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.535ea0f3dcbad3f725c4204f339e1e54.svg";
export { ForwardRef as ReactComponent };